import useGTMUtil, { GTMPageData } from '../../../lib/useGTMUtil';

export default () => {
  const { postGTMData } = useGTMUtil();

  const accountSummary = 'account_summary';
  const pageDataAccountSummary: GTMPageData = {
    pageName: 'account summary',
    siteSection: 'billing and payment',
    siteSubSection: accountSummary,
    journeyName: 'myAccount',
    subJourneyName: accountSummary,
    pageTime: new Date().toISOString(),
  };

  const gtm_CurrentBill_NavigateToNMTTP = () => {
    postGTMData({
      pageData: pageDataAccountSummary,
      actionData: {
        actionLocation: 'content',
        actionType: 'click',
        actionLabel: 'NMTTP',
        actionTime: new Date().toISOString(),
        actionElement: 'link',
        actionSubType: 'click',
        actionOutcome: 'click',
      },
    });
  };

  return {
    gtm_CurrentBill_NavigateToNMTTP,
  };
};
